<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-badge :value="20">123</ot-badge>
            <ot-badge :value="200" :max="99">123</ot-badge>
            <ot-badge value="new">new</ot-badge>
            <ot-badge value="hot">hot</ot-badge>
            <ot-badge dot>DOT</ot-badge>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            // TODO 待整理
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-badge%20%3Avalue%3D%2220%22%3E123%3C%2Fot-badge%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-badge%20%3Avalue%3D%22200%22%20%3Amax%3D%2299%22%3E123%3C%2Fot-badge%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-badge%20value%3D%22new%22%3Enew%3C%2Fot-badge%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-badge%20value%3D%22hot%22%3Ehot%3C%2Fot-badge%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-badge%20dot%3EDOT%3C%2Fot-badge%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20TODO%20%E5%BE%85%E6%95%B4%E7%90%86%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
